
import * as ActionTypes from '../actionTypes';

export default (state={},action) => {

    switch(action.type){
        case ActionTypes.REQUEST_ASSIGN_PACKAGE_TO_USER:                
            return {
                ...state,
                loading:true,
                error:false,
                errorInfo:null,
                response: null
            }        
        case ActionTypes.RECEIVED_ASSIGN_PACKAGE_TO_USER:
            return {
                ...state,
                loading:false,
                response:action.res,
                error:false,
                errorInfo:null
            }
        case ActionTypes.ERROR_ASSIGN_PACKAGE_TO_USER:
            return{
                ...state,
                loading:false,
                error:true,
                errorInfo:action.err,
                response: null
            }
        case ActionTypes.CLEAR_ASSIGN_PACKAGE_TO_USER:
            return {}
        default: return state;
    }
} 